<template>
  <main>
    <div id="app" :data-locale="formattedLocale" @open-quickshop="DialogQuickshop.open({ product: $event, gtmConfig: { appSource: 'tent-sleepingbag-guide' } })" />
    <modal-or-panel-quickshop class-content="<lg:pb-0" position="bottom" :size="$viewport.lg ? 'lg' : undefined" />
  </main>
</template>

<script lang="ts" setup>
const { configExternalApps: { tentSleepingbagGuideUrl = '' } } = useFeatureFlags()
const formattedLocale = useFormattedLocale()
const { $viewport } = useNuxtApp()

useScriptTag(
  tentSleepingbagGuideUrl,
  undefined,
  {
    attrs: {
      fetchpriority: 'high'
    }
  }
)

useHead({
  bodyAttrs: {
    class: 'hide-chat-button'
  }
})

const DialogQuickshop = createDialog('quickshop', {
  type: () => ($viewport.lg ? 'modal' : 'panel'),
})

onMounted(() => setInteractionOrigin('tent-sleepingbag-guide'))
</script>
